import { ActionTypes } from "../constants/action-types";

export const setTreeDetail = (val) => {
  return {
    type: ActionTypes.SET_TREE_DATA,
    payload: val,
  };
};
